<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Siųsti pranešimai</h3>

    <zurnalas-siunciami-search :loading="loading" @search="searchSiunciami" />

    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.zus_busena`]="{ item }">
        <el-busena :busena="item.zus_busena" />
      </template>
      <template #[`item.pranesimas`]="{ item }">
        <div class="nowrap">
          <el-byla v-for="byla in item.bylos" :key="byla.byl_id" :byla="byla" />
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
          />
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="
          printData('zurnalassiunciami/print', 'Siusti pranesimai')
        "
        :disabled="canPrint"
        :loading="loading"
        >Spausdinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import math from '../../mixins/math'
import ZurnalasSiunciamiSearch from './ZurnalasSiunciamiSearch'
import print from '../../mixins/print'

export default {
  name: 'ZurnalasSiunciami',
  components: {
    ZurnalasSiunciamiSearch,
  },
  mixins: [math, print],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      zurnalas_siunciami: [],
      searchData: {},
      headers: [
        {
          text: 'Siųsto pranešimo registracijos numeris',
          align: 'start',
          value: 'zus_numeris',
        },
        {
          text: 'Adresatas',
          align: 'start',
          value: 'zus_adresatas',
        },
        {
          text: 'Adresato el. paštas',
          align: 'start',
          value: 'zus_adresato_el_pastas',
        },
        {
          text: 'Siųsto pranešimo rūšis',
          align: 'start',
          value: 'zus_dokumento_rusis',
        },
        {
          text: 'Registracijos numeris',
          align: 'start',
          value: 'zug_numeris',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'zus_identifikavimo_kodas',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'zus_busena',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'zus_busenos_data',
        },
        {
          text: 'Dokumentai',
          align: 'center',
          sortable: false,
          value: 'pranesimas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
    }
  },
  computed: {
    ...mapGetters(['listInfo']),
    filterItemList() {
      return this.zurnalas_siunciami.map(item => {
        item.hipotekaTipas = HipotekaMap['hipotekaTipas'][item.zug_obj_tipas]
          ? HipotekaMap['hipotekaTipas'][item.zug_obj_tipas].title
          : item.zug_obj_tipas

        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: item.zus_numeris,
          }
        })
        if (item.obj_id) {
          item.canEdit = true
        }
        if (item.pra_id) {
          item.canEdit = true
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    //this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`zurnalassiunciami`, data)
        .then(res => {
          this.zurnalas_siunciami = res.data.zurnalas_siunciami
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchSiunciami(searchData) {
      this.searchData = searchData
      this.loading = true

      let resetPageNr = true
      if (this.$route.params.toList) {
        this.pagination = this.listInfo.pagination
        resetPageNr = false
        this.$route.params.toList = false
      }
      this.getData(resetPageNr)
    },
    editItem(item) {
      if (item.pra_id) {
        this.editPrasymas(item)
        return
      }

      this.editHipoteka(item)
    },
    editHipoteka(item) {
      const objektasID = item.obj_id

      const listInfo = {
        obj_id: item.obj_id,
        routeName: 'zurnalasSiunciami',
        pagination: this.pagination,
        search: this.searchData,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'hipotekaRegistravimas',
          params: {
            objektasID: objektasID,
          },
        })
      )
    },
    editPrasymas(item) {
      const prasymasID = item.pra_id

      const listInfo = {
        pra_id: item.pra_id,
        routeName: 'zurnalasSiunciami',
        pagination: this.pagination,
        search: this.searchData,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'regPrasymasRegistravimas',
          params: {
            prasymasID: prasymasID,
          },
        })
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
